const _load = () => import('./load')

if (!('fetch' in window)) {
  _load()
}
